import React from "react";
import { Flex, Link, Text, Box, keyframes, Badge, Icon } from "@chakra-ui/react";
import { FaBirthdayCake, FaHeart } from "react-icons/fa";
import config from "config";

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export default function Footer(props) {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems="center"
      justifyContent="space-between"
      px='30px'
      pb='20px'
      pt='10px'
      width="100%"
      height="100%"
      gap={4}
    >
      {/* Left side - Copyright */}
      <Text
        fontSize='sm'
        color='white'
        textAlign="center"
        mb={{ base: "10px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()}{"-" + config.version},{" "}
        <Text as='span'>
          Développé avec{" "}
        </Text>
        <Text 
          as='span' 
          display="inline-block"
          animation={`${pulse} 1s ease-in-out infinite`}
        >
          ❤️
        </Text>
        <Text as='span'> par </Text>
        <Link 
          href='https://www.nelx.net'
          color="orange.400"
          fontWeight="bold"
          transition="all 0.2s ease"
          _hover={{ 
            color: "orange.300",
            textDecoration: "none",
            textShadow: "0 0 10px rgba(251, 146, 60, 0.5)",
          }}
        >
          NELX
        </Link>
      </Text>

      {/* Right side - 2nd Anniversary Badge */}
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        bg="linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%)"
        border="1px solid rgba(139, 92, 246, 0.3)"
        borderRadius="full"
        px={4}
        py={2}
        animation={`${pulse} 3s ease-in-out infinite`}
        transition="all 0.3s ease"
        _hover={{
          bg: "linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(168, 85, 247, 0.3) 100%)",
          boxShadow: "0 0 20px rgba(139, 92, 246, 0.3)",
          transform: "scale(1.02)",
        }}
      >
        <Icon as={FaBirthdayCake} color="purple.300" boxSize={4} />
        <Text
          fontSize="sm"
          fontWeight="bold"
          bgGradient="linear(to-r, purple.300, pink.300, purple.300)"
          bgSize="200% auto"
          bgClip="text"
          animation={`${shimmer} 3s linear infinite`}
        >
          XGuard existe depuis février 2024 🚀
        </Text>
      </Box>
    </Flex>
  );
}